import React from 'react'
import LabelText from '../../../ui/LabelText'
import Switch from '../../../ui/CustomSwitch'

interface FilterSectionProps {
    isTransferMarket: boolean;
    isVolatility: boolean;
    toggleTransferMarket: () => void;
    toggleVolatility: () => void;
}


const ValueGraphFilterSection: React.FC<FilterSectionProps> = ({
    isTransferMarket,
    isVolatility,
    toggleTransferMarket,
    toggleVolatility,
}) => {
    return (
        <div className='value-graph-filters'>
            <LabelText className='value-text overall-text'>€ value</LabelText>
            <div className='value-graph-market-value'>
                {/* <div className='value-graph-search'>
                    <div className='square-box'></div>
                    <LabelText className='market-value-text'>MF market valuation</LabelText>
                </div> */}
                <div className='value-graph-search'>
                    <div className='square-box transfer-market'></div>
                    <LabelText className='market-value-text'>Transfermrkt</LabelText>
                    {/* <Switch id="transfermarket"
                        toggled={isTransferMarket} onChange={toggleTransferMarket}
                        source='Filter' isByComparison={false} /> */}
                </div>
                {/* <div className='value-graph-search'>
                    <LabelText className='market-value-text'>Volatility</LabelText>
                    <Switch id="volatility"
                        toggled={isVolatility} onChange={toggleVolatility}
                        source='Filter' isByComparison={false}/>
                </div> */}

            </div>
        </div>
    )
}

export default ValueGraphFilterSection;
